import React from 'react';
import style from './style.scss'
import newId from '../../utils/newid';
import Label from './Label';

const RenderToggle = (props) => {
    const {item, field,isReadOnly} = props;

    const id = newId();
    return (
        <div className={style.typeToggle+" "+(isReadOnly?style.isReadOnly:'')}>
            <label className={style.toggleSwitch}>
                <input
                    type="checkbox"
                    id={id}
                    defaultChecked={(typeof field !== "undefined") ? field[item.item] : false}
                    disabled={isReadOnly}
                    onChange={(t) => {
                        return props.handleChange(t.target.checked)
                    }}
                />
                <span className={style.toggleSlider}></span>
            </label>
            {
                (typeof item.label !== 'undefined') &&
                <Label
                    id={id}
                    label={item.label}
                />
            }
        </div>
    )
}

export default RenderToggle;
